export default () => ({
  show: {
    loader: false,
    translucent: false,
    announcements: false,
  },
})
